export default __webpack_public_path__ + "static/media/graphic.48ebfc2a.webp";